import React from "react";

import Card from "../Card/Card";
import CardGrid from "../Card/CardGrid";
import LoadingCenter from "../LoadingCenter";

import { useHttp } from "../../hooks/useHttp";
import { useQuery } from "@tanstack/react-query";
import { AlertOctagon, BarChart2, MessageCircle, MessageSquare } from "react-feather";

const CardsManagement = props => {
  const request = useHttp();

  const { data: dash, isLoading } = useQuery({ queryKey: ["dash-management"], queryFn: () => request({ url: "/dash/available", method: "GET" }) });
  const { data: dashTransfers, isLoading: isLoadingTransfers } = useQuery({ queryKey: ["dash-transfers"], queryFn: () => request({ url: "/dash/transfers/prospect", method: "GET" }) });

  if (isLoading || isLoadingTransfers) return <LoadingCenter />;

  return (
    <CardGrid>
      <Card icon={<AlertOctagon />} title={dash?.data?.available} subtitle="Disponíveis" color="primary" />

      <Card icon={<AlertOctagon />} title={dash?.data?.buys} subtitle="Arrematantes disponíveis" />

      <Card icon={<MessageCircle />} title={dashTransfers?.data?.com} subtitle="Transferências diretas com menção" iconColor="blue" />

      <Card icon={<MessageSquare />} title={dashTransfers?.data?.sem} subtitle="Transferências diretas sem menção" iconColor="purple" />

      <Card icon={<BarChart2 />} title={dash?.data?.average_em_dia} subtitle="Média p/ vendedor: Disponíveis // Em dia" iconColor="purple" />
    </CardGrid>
  );
}

export default CardsManagement;